import type { UserRouteEntitlementsAction } from './actions';
import type { UserRouteEntitlementsState } from './types';

export function userRouteEntitlementsReducer(
    state: UserRouteEntitlementsState,
    action: UserRouteEntitlementsAction,
): UserRouteEntitlementsState {
    switch (action.type) {
        case 'SET_SCOPE':
            if (state.userId === action.userId) return state;
            return { ...state, userId: action.userId };
        case 'SET_SEARCH':
            if (state.search === action.value) return state;
            return { ...state, search: action.value };
        case 'START_ROUTE_WRITE':
            if (state.pendingRouteIds.includes(action.routeId)) return state;
            return { ...state, pendingRouteIds: [...state.pendingRouteIds, action.routeId] };
        case 'FINISH_ROUTE_WRITE':
            if (!state.pendingRouteIds.includes(action.routeId)) return state;
            return { ...state, pendingRouteIds: state.pendingRouteIds.filter((id) => id !== action.routeId) };
        case 'START_BULK_WRITE':
            if (state.bulkPending) return state;
            return { ...state, bulkPending: true };
        case 'FINISH_BULK_WRITE':
            if (!state.bulkPending) return state;
            return { ...state, bulkPending: false };
        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
